import React, { Component } from "react";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Input,
  Table,
  Button
} from "reactstrap";

import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import Select from "react-select";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import DatePicker from "react-datepicker";
import Collapsible from 'react-collapsible';
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Moment from "react-moment";
import Pagination from "react-js-pagination";
import "react-confirm-alert/src/react-confirm-alert.css";

import { BtnPermissions } from "../../lib/BtnPermissions"
import DisplayRecordText from "../controls/_DisplayRecordText"
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import ButtonExt from '../controls/ButtonExt'
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'

import { currentDate, parseDatetime } from "../../lib/common";

// Import actions
import * as ordersConstant from './constants'
import * as ordersAction from './actions'
import { storedb } from "../../views/client/storedb";

class ProcessOrders extends Component {
  constructor(props) {
    super(props);

    let dbContext = storedb();
    this.state = {
      searchCondition: {
        startDate: currentDate().startOf('month'),
        endDate: currentDate(),
        trangThai: 2, //đang xử lý
        keyword: '',
        Nvkd: [],
        type: 1,
        page: 1,
        per_page: 20,
      },
      preFix: 'orders-',
      store_id: dbContext.getStoreId(),
      kho_id: dbContext.getKhoId(),
      khoIds: dbContext.getKhoIds(),
      listNvkd: [],
      total_record: 0,
      total_amount: 0,
      itemsChecked: [],
    };
  }
  handleControlChange(name, e) {
    let { searchCondition } = this.state
    switch (name) {
      case "startDate":
        searchCondition.startDate = e
        break;
      case "endDate":
        searchCondition.endDate = e
        break;
      case "TrangThai":
        searchCondition.trangThai = e.target.value
        break;
      case "type":
        searchCondition.type = parseInt(e.target.value)
        break;
      case "keyword":
        searchCondition.keyword = e.target.value
        break;
    }
    this.setState({ searchCondition });
  }

  handlePageChange = pageNumber => {
    let { searchCondition } = this.state
    searchCondition.page = parseInt(pageNumber || 1);
    return this.setState({ searchCondition }, () => {
      this.fetchList(pageNumber, true)
    })
  }
  search = () => {
    if (this.props.processOrders.listRequesting) {
      return false;
    }
    if (this.state.searchCondition.Nvkd.length == 0) {
      this.props.setProcessError("Bạn phải chọn 1 trình dược viên để tạo đơn")
      return false;
    }
    let { searchCondition } = this.state
    searchCondition.page = 1
    return this.setState({ searchCondition }, () => {
      this.fetchList(1, true)
    });
  };
  getListNVKD() {
    const { processOrdersListNvRequest } = this.props
    const requestData =
    {
      store_id: this.state.store_id
    }
    const callBack = (data) => {
      this.setState({
        listNvkd: data
      });
    }
    return processOrdersListNvRequest(requestData, callBack)
  }
  buildSelectOptionNVKD(listNVKD) {
    var options = [];
    if (listNVKD && listNVKD.length > 0) {
      listNVKD.map((item) => { options.push({ value: item.Id, label: item.TenDayDu }) }
      );
    }
    return options;
  }

  fetchList = (page, useCached) => {
    const { processOrdersListRequest } = this.props
    const { searchCondition } = this.state
    const requestData =
    {
      store_id: this.state.store_id,
      type: searchCondition.type,
      quanLyId: this.getQuanLyIds(),
      keyword: searchCondition.keyword,
      trangThai: searchCondition.trangThai,
      startDate: searchCondition.startDate.unix(),
      endDate: searchCondition.endDate.endOf('days').unix(),
      page: page || searchCondition.page,
      per_page: searchCondition.per_page,
      use_cached: useCached || false,
    }
    return processOrdersListRequest(requestData)
  }
  getQuanLyIds = () => {
    if (!this.state.searchCondition.Nvkd || this.state.searchCondition.Nvkd.length === 0) {
      return 0
    } else {
      return this.state.searchCondition.Nvkd[0].value
    }
  }
  onChangeItem = (itemPerPage) => {
    let { searchCondition } = this.state
    searchCondition.per_page = itemPerPage
    this.setState({ searchCondition }, () => {
      this.search();
    });
  }
  storeSearchCondition = () => {
    let { preFix, searchCondition } = this.state
    const key = `${preFix}${searchCondition.type}`
    let cached = JSON.stringify(searchCondition)
    sessionStorage.setItem(key, cached)
  }
  mergeSearchCondition = (type, callback) => {
    try {
      let { preFix, searchCondition } = this.state
      const key = `${preFix}${type}`
      const cached = sessionStorage.getItem(key)
      if (cached || cached != '') {
        let searchConditionCached = JSON.parse(cached)
        if (searchConditionCached) {
          searchCondition = { ...searchCondition, ...searchConditionCached }
          searchCondition.startDate = parseDatetime(searchCondition.startDate)
          searchCondition.endDate = parseDatetime(searchCondition.endDate)
        }
      }
      this.setState({ searchCondition }, callback)
    } catch (error) {
      callback()
    }
  }
  initData = () => {
    this.mergeSearchCondition(this.state.searchCondition.type, () => {
      this.getListNVKD()
      this.fetchList(1, true)
    })
  }

  createExportOrderClick = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Xác nhận tạo phiếu xuất kho cho danh sách đơn đã chọn?</p>
            <button className="text-danger" onClick={() => {
              const orderIds = this.state.itemsChecked
              const formData = {
                IdBans: orderIds,
                nhanVienId: this.state.searchCondition.Nvkd[0].value
              }
              this.props.processOrderCreate(formData, (data) => {
                if (data.xuatKho) {
                  this.props.history.push(`/process-order-detail/${data.xuatKho.Id}`);
                }
              })
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  onHandleRemove = () => {
    let { searchCondition } = this.state
    searchCondition.Nvkd = []
    this.setState({ searchCondition })
  }
  onHandleChoice = (nodesChecked) => {
    let { searchCondition } = this.state
    searchCondition.Nvkd = nodesChecked
    this.setState({ searchCondition })
  }
  itemChecked = ({ target }) => {
    let { itemsChecked } = this.state
    const value = target.value
    if (target.checked) {
      const index = itemsChecked.indexOf(value)
      if (index === -1) {
        itemsChecked.push(value)
      }
    } else {
      const index = itemsChecked.indexOf(value)
      if (index > -1) {
        itemsChecked.splice(index, 1)
      }
    }
    this.setState({ itemsChecked })
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  componentDidMount() {
    this.initData()
  }
  componentWillUnmount() {
    this.storeSearchCondition()
  }
  componentWillReceiveProps(nextprops) {
    let { searchCondition } = this.state
    if (nextprops.processOrders.type == ordersConstant.PROCESS_ORDERS_LIST_SUCCESS) {
      let { list, item } = nextprops.processOrders;
      searchCondition.page = item.page
      searchCondition.per_page = item.per_page
      this.setState(
        {
          searchCondition,
          total_record: item.total_record || 0,
          total_amount: item.total_amount || 0,
          page: item.page,
          per_page: item.per_page,
          list: list,
          itemsChecked: []
        }
      )
    }
  }

  render() {
    const {
      list,
      searchCondition,
      itemsChecked
    } = this.state
    const {
      processOrders: {
        requesting,
        messages,
        errors
      },
    } = this.props
    const { type } = searchCondition
    const isAvailableApprove = () => {
      return itemsChecked.length > 0
    }
    const startIndex = (searchCondition.page > 0 ? searchCondition.page - 1 : 0) * searchCondition.per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting}>
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="startDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Từ ngày"
                      selected={searchCondition.startDate}
                      onChange={this.handleControlChange.bind(
                        this,
                        "startDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1  pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker
                      name="endDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Đến ngày"
                      selected={searchCondition.endDate}
                      popperClassName="react-end-date"
                      popperPlacement="top-end"
                      onChange={this.handleControlChange.bind(
                        this,
                        "endDate"
                      )}
                      required
                      className={"form-control"}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="4" className="mb-1 pl-2 pr-2">
                  <CheckboxTreeList
                    placeholder={`--Nhân viên KD--`}
                    nodes={this.state.listNvkd}
                    checked={searchCondition.Nvkd}
                    isMultiChoice={false}
                    onHandleRemove={(item) => this.onHandleRemove(item)}
                    onChoice={e => this.onHandleChoice(e)}
                  />
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off">
                      Hóa đơn
                    </InputGroupAddon>
                    <Input
                      name="keyword"
                      placeholder="Mã hóa đơn"
                      value={searchCondition.keyword}
                      onChange={this.handleControlChange.bind(
                        this,
                        "keyword"
                      )}
                      autoComplete="off"
                      onKeyDown={e => this.keyPress(e)} 
                    />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <select
                      className="form-control"
                      value={searchCondition.type || ''}
                      onChange={this.handleControlChange.bind(this, "type")}
                    >
                      <option value={1}>Đơn thường</option>
                      <option value={2}>Đơn đại lý</option>
                    </select>
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2">
              <Button size="md" color="success" className="mr-1 pull-left" onClick={this.search}>
                <i className="fa fa-search" /> Tìm kiếm
              </Button>
              <ButtonExt isDisabled={!isAvailableApprove()} size="md" btnClass="pull-left mr-1 mb-1" btnClick={this.createExportOrderClick}
                iconClass="fa-check" displayText="Tạo phiếu xuất kho" color="primary"
                permission={BtnPermissions.DonXuatKho.CREATE_PROCESS_ORDER} />
              <div className="clearfix"></div>
            </div>
            <div className="w-100">
              {!requesting && !!errors.length && (
                <Errors message="Failure to signup due to:" errors={errors} />
              )}
              {!requesting && !!messages.length && (
                <Messages messages={messages} />
              )}
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30" className="text-center table-border-right">#</th>
                    <th scope="col" width="30" className="text-center table-border-right">

                    </th>
                    <th scope="col" width="150" className="text-center table-border-right">Mã đơn hàng</th>
                    <th scope="col" width="200" className="text-left table-border-right">Khách Hàng</th>
                    <th scope="col" width="100" className="text-center table-border-right">Ngày lập</th>
                    <th scope="col" width="200" className="text-center table-border-right">Nhân viên KD</th>
                    <th scope="col" width="150" className="text-center table-border-right">Nơi xuất</th>
                    <th scope="col" className="text-left table-border-right">Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center table-border-right">{startIndex + (idx + 1)}</td>
                        <td className="text-center table-border-right"> <input type="checkbox" value={res.Id} onChange={e => this.itemChecked(e)} /></td>
                        <td className="text-center table-border-right"> {res.MaDonHang}</td>
                        <td className="text-left table-border-right">{res.TenKhachHang}</td>
                        <td className="text-center table-border-right">{res.NgayLap && <Moment format="HH:mm DD/MM">{`${res.NgayLap}`}</Moment>}</td>
                        <td className="text-center table-border-right">{res.TenNhanVien}</td>
                        <td className="text-center table-border-right">{res.NoiXuat}</td>
                        <td className="text-left table-border-right">{res.GhiChu}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <nav>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </nav>
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  processOrders: state.processOrders,
  client: state.client
});

const connected = connect(
  mapStateToProps,
  {
    processOrdersListRequest: ordersAction.processOrdersListRequest,
    processOrdersListNvRequest: ordersAction.processOrdersListNvRequest,
    processOrderCreate: ordersAction.processOrderCreate,
    setProcessError: ordersAction.setProcessError,
    setProcessMessage: ordersAction.setProcessMessage,
    setCallbackFunc: ordersAction.setCallbackFunc,
  }
)(ProcessOrders);

const formed = reduxForm({
  form: "processOrders"
})(connected);

export default formed;



// WEBPACK FOOTER //
// ./src/views/ProcessOrders/ProcessOrders.js